$(function () {
    //buscador
    $('#avanzado').keypress(function (e) {
        if (e.which == 13) {
            Buscador.buscar()
        }
    });

    //$.material.init();
    if (!Cookie.get('set_inicial')) {
        Table.reset();
        Cookie.set("set_inicial", 1, 9000, '/');
    }
    //cookies iniciales
    for (var i = 1; i <= 25; i++) {
        if (!Cookie.get('col-' + i)) {
            Cookie.set('col-' + i, 1, 9000, '/')
        }
    }
    ajustesVisuales();

    var secActual = getVarsUrl().sec;

    switch (secActual) {
        /**
         * Seccion add reclamos
         */
        case 'addReclamo':

            //$('#fecha_ingreso').datepicker();
            var product = $('#producto');
            var id = product.val();

            //cargar los clientes asociados
            PROD.ClientesAsociados(id);
            //cargar los subproducto
            PROD.SubProductos(id);

            //cargar los campos extra
            Campos.LoadCampos(id);

            product.on('change', function () {
                id = $('#producto').val();
                PROD.SubProductos(id);
                PROD.ClientesAsociados(id);
                Campos.LoadCampos(id);
            });

            $('#sub').change(function () {
                console.log('cambio de sub');
                PROD.ProblemasProducto($('#sub').val());
            });

            break;

        /**
         * Seccion reclamos
         */
        case 'reclamos':
            //cargar los reclamos
            LoadPHP('sec/listarReclamos.php?id_producto=0', '.data');
            //iniciar el mapa
            MAPA.Init('map');
            //fecha
            //$('#fecha').datepicker();

            var iden = $("#producto_filter");
            var cliente = $("#cliente_filtro");
            var estado = $("#estado-filter");
            var subProducto = $("#sub-filter");
            var hideCerrados = $("#hide_cerrados");

            PROD.SubProductosReclamos(iden.val(), subProducto);

            iden.change(function () {
                var producto = $('#producto_filter');
                PROD.SubProductosReclamos(producto.val(), subProducto);
            });

            //cookie reclamo
            Cookie.set('producto_iden', 0, 1, '/');

            if (getVarsUrl().lastReclamo) {
                BuscarID.buscar(getVarsUrl().lastReclamo)
            }

            hideCerrados.change(function () {
                if ($(this).is(":checked")) {
                    hideCerrados.val(1);
                } else {
                    hideCerrados.val(0);
                }
                console.log('Valor hide->' + hideCerrados.val());
                RECLAMOS.loadReclamosTable();
            });

            //al cambiar el producto
            iden.change(function () {
                RECLAMOS.loadReclamosTable();
            });

            cliente.change(function () {
                RECLAMOS.loadReclamosTable();
            });

            subProducto.change(function () {
                RECLAMOS.loadReclamosTable();
            });

            estado.change(function () {
                RECLAMOS.loadReclamosTable();
            });


            break;

        /**
         * Seccion proyectos
         */
        case 'proyectos':
            LoadPHP('sec/listarProyectos.php', '.data');
            FilterInformes.Botones();
            break;

        /**
         * Secccion editar proyecto
         */
        case 'editProyecto':
            break;

        /**
         * Seccion productos
         */
        case 'productos':
            LoadPHP('sec/listarProductos.php', '.data');
            break;

        /**
         * Seccion usuarios
         */
        case 'usuarios':
            LoadPHP('sec/listarUsers.php', '.data');
            break;

        /**
         * seccion informes
         */
        case 'informe':
            var proyecto = $('#proyecto');
            var id_proyecto = proyecto.val();
            PROYECT.Etapas(id_proyecto);

            proyecto.on('change', function () {
                var id_proyecto = proyecto.val();
                PROYECT.Etapas(id_proyecto);
            });

            //$('#fecha').datepicker({dateFormat: 'dd-mm-yy'});
            break;

        case 'editInforme':
            var proyecto = $('#proyecto');
            var id_proyecto = proyecto.val();
            PROYECT.Etapas(id_proyecto);

            proyecto.on('change', function () {
                var id_proyecto = proyecto.val();
                PROYECT.Etapas(id_proyecto);
            });
            break;

        /**
         * Seccion añadir campo
         */
        case 'addCampo':
            ajustesVisuales();
            break;

        /**
         * Seccion ajustes
         */
        case 'ajustes':
            LoadPHP('sec/listarHoras.php', '.horas');
            LoadPHP('sec/listarTipos.php', '#tiposP');
            LoadPHP('sec/listarEtapasP.php', '#listEtapas');
            LoadPHP('sec/listarSoluciones.php', '#listSoluciones');
            LoadPHP('sec/listarProblemas.php', '#listProblemas');
            LoadPHP('sec/listarReferencias.php', '#listRef');

            //para asignar
            var product = $('#es #producto');
            var id = product.val();
            PROD.SubProductos(id);

            product.on('change', function () {
                var product = $('#es #producto');
                id = product.val();
                PROD.SubProductos(id);
            });

            //para traslado de problemas
            //Origen
            var prod_origen = $('#copy').find('#prod_origen');
            PROD.SubProductos(prod_origen.val(), '#sub2', 'sub_origen');

            prod_origen.on('change', function () {
                var prod_origen = $('#copy').find('#prod_origen');
                PROD.SubProductos(prod_origen.val(), '#sub2', 'sub_origen');
            });

            //destino
            var prod_destino = $('#copy').find('#prod_destino');
            PROD.SubProductos(prod_destino.val(), '#sub3', 'sub_destino');

            prod_destino.on('change', function () {
                var prod_destino = $('#copy').find('#prod_destino');
                PROD.SubProductos(prod_destino.val(), '#sub3', 'sub_destino');
            });


            break;

        case 'editReclamo':
            //para editar un reclamo
            console.log('Editando reclamos');
            var product2 = $('#producto');
            var id2 = product2.val();

            product2.on('change', function () {
                console.log('cambio');
                product2 = $('#producto');
                id2 = product2.val();
                PROD.SubProductos(id2);
            });
            break;

        case 'equipos':
            LoadPHP('sec/listarEquipos.php', '.data');
            break;

        case 'empleados':
            LoadPHP('sec/listarEmpleados.php', '.data');
            break;

        case 'buscar':
            Buscador.load();
            break;

        case 'asignar':
            LoadPHP('sec/listarAsociadosEmpleado.php', '.data');
            //cargar los subproducto
            var pro = $('#producto');
            PROD.SubProductos(pro.val());
            pro.change(function () {
                PROD.SubProductos(pro.val());
            });
            break;

        case 'historialPlaca':
            LoadPHP('sec/listarHistorialPlaca.php', '.data');
            break;

        case'reparaciones':
            LoadPHP('sec/listarReparaciones.php', '.data');
            break;

        case 'reportes':
            LoadPHP('sec/listarReportes.php', '.data');
            break;

        case 'Apps':
            LoadPHP('sec/listarApps.php', '.data');
            break;

        case 'apps':
            LoadPHP('sec/listarApps.php', '.data');
            break;


        case 'setsApp':
            LoadPHP('sec/listarCiudadesApp.php?app='+getVarsUrl().id, '.data');
            break;



        case 'paTable':

            break;
    }
});